var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/core-js/library/modules/_user-agent.js
// module id = 971
// module chunks = 0